import React from "react";
import useAppUpdate from "../Hooks/useAppUpdate";
import UpdateConfirmModal from "./UpdateConfirmModal";

const UpdateAvailableBanner = () => {
  const { updateAvailable, isConfirmOpen, isUpdating, openConfirm, closeConfirm, confirmAndReload } = useAppUpdate();

  if (!updateAvailable) return null;

  return (
    <>
      <div className="block md:hidden fixed bottom-6 left-1/2 -translate-x-1/2 z-40 bg-canvas-primary text-white px-4 py-2.5 rounded-full shadow-lg flex items-center gap-3 max-w-[90vw]">
        <span className="text-xs font-medium whitespace-nowrap">Update available</span>
        <button
          type="button"
          className="text-xs font-bold bg-white text-canvas-primary rounded-full px-3 py-1.5 flex-shrink-0"
          onClick={openConfirm}
        >
          Update now
        </button>
      </div>
      <UpdateConfirmModal open={isConfirmOpen} onClose={closeConfirm} onConfirm={confirmAndReload} isUpdating={isUpdating} />
    </>
  );
};

export default UpdateAvailableBanner;
